/**
 * Created by decipaliz on 28.06.2024
 */

const LanternStartComponent = cc.Node.extend({
    ctor: function (level) {
        this._super();

        const styles = cleverapps.styles.LanternStartComponent;

        const res = bundles.lantern_start.frames.lantern_start_bg_png;

        let bg;
        if (styles.bg.scale9) {
            bg = cleverapps.UI.createScale9Sprite(res, cleverapps.UI.Scale9Rect.TwoPixelXY);
            bg.setContentSize(styles.bg.scale9);
        } else {
            bg = new cc.Sprite(res);
        }

        bg.setAlignment(styles.bg);

        this.setContentSize(bg);
        this.setAnchorPoint(0.5, 0.5);

        this.addChild(bg);

        this.level = level;

        const streak = Lantern.GetStreak(level);
        const rewards = LanternStartComponent.REWARDS[streak - 1];

        const lantern = new cc.Node();

        const lanternIcon = new cleverapps.Spine(bundles.lantern_start.jsons.lantern_component_json);
        lanternIcon.setAnimation(0, `idle_${streak}`);

        lantern.setAlignment(styles.lanternIcon);

        lantern.addChild(lanternIcon);
        this.addChild(lantern);

        lantern.setScale(0);
        lantern.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                lantern.setScale(0.5);
                lantern.setVisible(true);

                if (cleverapps.config.ui === "heroes") {
                    StandartAnimations.rays(lantern, { skin: "white", size: 120 });
                }
            }),
            new cc.ScaleTo(0.4, 1, 1).easing(cc.easeBackOut()),
            new cc.CallFunc(() => {
                if (streak > 0) {
                    cleverapps.tooltipManager.onClick(lanternIcon, {
                        rewards,
                        location: cleverapps.UI.Tooltip.LOCATION_ABOVE,
                        control: "lanternStartTooltip"
                    });
                }
            })
        ));

        if (streak > 0) {
            cleverapps.UI.onClick(lanternIcon, () => {
                cleverapps.tooltipManager.onClick(lanternIcon, {
                    rewards,
                    location: cleverapps.UI.Tooltip.LOCATION_ABOVE,
                    control: "lanternStartTooltip"
                });
            }, {
                interactiveScale: false
            });
        }

        cleverapps.focusManager.showControlsWhileFocused("lanternStartTooltip");

        const helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_light,
            callback: function () {
                cleverapps.focusManager.display({
                    focus: "LanternHelp",
                    stack: true,
                    action: function (f) {
                        new GuideWindow({
                            name: "LanternGuideWindow",
                            bundle: bundles.lantern_guide_window
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
        helpButton.setScale2(styles.helpButton.scale);
        helpButton.baseScale = styles.helpButton.scale;
        helpButton.setAlignment(styles.helpButton);
        this.addChild(helpButton);

        const label = cleverapps.UI.generateOnlyText(Messages.get(`LevelStartWindow.Lantern.${cleverapps.config.ui}`), cleverapps.styles.FONTS.LANTERN_START_COMPONENT_TEXT);
        label.setDimensions(styles.label.width, styles.label.height);
        label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        label.setAlignment(styles.label);
        this.addChild(label);

        const progressBar = new cleverapps.Spine(bundles.lantern_start.jsons.lantern_progress_json);
        progressBar.setAlignment(styles.progressBar);

        this.addChild(progressBar);

        if (streak === 0 || streak === 3) {
            progressBar.setAnimation(0, `idle_${streak}`);
        } else {
            progressBar.setAnimation(0, `idle_${streak - 1}`);
            progressBar.runAction(new cc.Sequence(
                new cc.DelayTime(0.2),
                new cc.CallFunc(() => {
                    progressBar.setAnimationAndIdleAfter(`stage_${streak}`, `idle_${streak}`);
                }),
                new cc.DelayTime(0.7),
                cleverapps.effects.fireAction("lantern.score")
            ));
        }
    }
});

LanternStartComponent.REWARDS = [
    { boosters: { 5: 3 } },
    { boosters: { 5: 3, 6: 3 } },
    { boosters: { 5: 3, 6: 3, 7: 1 } }
];

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    LANTERN_START_COMPONENT_STROKE: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE_COLOR,
        size: 2
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LANTERN_START_COMPONENT_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LANTERN_START_COMPONENT_STROKE
    }
});

cleverapps.styles.LanternStartComponent = {
    bg: {
        x: { align: "center" },
        y: { align: "center" }
    },
    lanternIcon: {
        x: { align: "center", dx: -170 },
        y: { align: "center", dy: 6 }
    },
    helpButton: {
        x: { align: "right", dx: -26 },
        y: { align: "top", dy: -26 },
        scale: 0.8
    },
    label: {
        width: 240,
        height: 150,
        x: { align: "center", dx: 80 },
        y: { align: "center", dy: 55 }
    },
    progressBar: {
        x: { align: "center", dx: 80 },
        y: { align: "center", dy: -50 }
    }
};